import { useState } from 'react'
import { Modal, Button, Table } from 'antd'
import { Round } from '../../functions/globalFunctions'

const InvoiceModal = ({ Data, id, mode }) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [data] = useState(Data)
  let vendorId = localStorage.getItem('vendorId')

  const showModal = () => {
    setIsModalVisible(true)
    // setData(
    //   Data.filter((data) => {
    //     return data.quantity >= 0;
    //   })
    // );
  }

  const handleOk = () => {
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // console.log(' - - - - - - Data ', Data)

  const productColumns =
    mode === 'offline' && (vendorId == 897 || vendorId == 1003)
      ? [
          {
            title: 'Product Code',
            width: 500,
            dataIndex: 'pId',
          },
          {
            title: 'Product Name',
            width: 300,
            dataIndex: 'name',
          },
          {
            title: 'Shop Name',
            width: 300,
            dataIndex: 'shop',
          },

          {
            title: 'Category',
            width: 200,
            dataIndex: 'category',
          },
          {
            title: 'Brand',
            width: 200,
            dataIndex: 'brand',
          },
          {
            title: 'Class',
            width: 200,
            dataIndex: 'productSubCategory',
          },
          {
            title: 'Sub Class',
            width: 200,
            dataIndex: 'productSubSubCategory',
          },
          {
            title: 'Discount Discription',
            dataIndex: 'discount_description',
            width: 200,
          },
          {
            title: 'Size',
            dataIndex: 'size',
          },
          {
            title: 'Inseam',
            dataIndex: 'inseam',
          },
          // {
          //   title: 'Color',
          //   dataIndex: 'color',
          // },
          {
            title: 'Price',
            dataIndex: 'price',
            sorter: (a, b) => a.price - b.price,
          },
          {
            title: 'Quantity',
            dataIndex: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
          },
          {
            title: 'Tax Amount',
            dataIndex: 'tax',
          },
          {
            title: 'Discount',
            dataIndex: 'discount',
          },
          {
            title: 'Net Total',
            dataIndex: 'netTotal',
            sorter: (a, b) => a.total - b.total,
          },
          {
            title: 'Grand Total',
            dataIndex: 'grandTotal',
          },
        ]
      : mode === 'offline'
      ? [
          // {
          //   title: "Product ID",
          //   dataIndex: "pId",
          // },
          {
            title: 'Product Name',
            width: 300,
            dataIndex: 'name',
          },
          {
            title: 'Shop Name',
            width: 300,
            dataIndex: 'shop',
          },
          {
            title: 'Category',
            width: 200,
            dataIndex: 'category',
          },
          {
            title: 'Technical Detail',
            dataIndex: 'detail',
            width: 200,
          },
          {
            title: 'Size',
            dataIndex: 'size',
          },
          {
            title: 'Color',
            dataIndex: 'color',
          },
          {
            title: 'Price',
            dataIndex: 'price',
            sorter: (a, b) => a.price - b.price,
          },
          {
            title: 'Quantity',
            dataIndex: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
          },
          {
            title: 'Tax Amount',
            dataIndex: 'tax',
          },
          {
            title: 'Discount',
            dataIndex: 'discount',
          },
          {
            title: 'Net Total',
            dataIndex: 'netTotal',
            sorter: (a, b) => a.total - b.total,
          },
        ]
      : [
          {
            title: 'Product ID',
            dataIndex: 'pId',
          },
          {
            title: 'Product Name',
            width: 300,
            dataIndex: 'name',
          },
          // {
          //   title: "Shop Name",
          //   width: 300,
          //   dataIndex: "shop",
          // },
          {
            title: 'Category',
            width: 200,
            dataIndex: 'category',
          },
          {
            title: 'Technical Detail',
            dataIndex: 'detail',
            width: 200,
          },
          {
            title: 'Size',
            dataIndex: 'size',
          },
          {
            title: 'Color',
            dataIndex: 'color',
          },
          {
            title: 'Notes',
            dataIndex: 'notes',
          },
          {
            title: 'Price',
            dataIndex: 'price',
            sorter: (a, b) => a.price - b.price,
          },
          {
            title: 'Quantity',
            dataIndex: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
          },
          {
            title: 'Tax Amount',
            dataIndex: 'tax',
          },

          // {
          //   title: 'Total',
          //   dataIndex: 'total',
          //   sorter: (a, b) => a.total - b.total,
          // },
          {
            title: 'Discount',
            dataIndex: 'discount',
          },
          {
            title: 'Net Total',
            dataIndex: 'netTotal',
            sorter: (a, b) => a.total - b.total,
          },
        ]

  return (
    <>
      <Button type='primary' onClick={showModal}>
        View Details
      </Button>
      <Modal
        title={`Invoice Number ${id} Details`}
        getContainer={false}
        footer={false}
        width={'auto'}
        maskClosable={false}
        visible={isModalVisible}
        // centered
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className='invoice-modal'>
          <Table
            columns={productColumns}
            loading={data ? false : true}
            dataSource={
              data &&
              data.map((data) => ({
                ...data,
                pId: data?.productCode || '',
                name: data?.productName || '',
                notes: data?.notes || '',
                price: data?.price || '',
                quantity: data?.quantity,
                tax: data?.taxAmount,
                taxPercent: data?.taxPercentage,
                shop: data?.shopName,
                discount: Round(data?.discount)?.toLocaleString(),
                netTotal: Round(data?.netTotal)?.toLocaleString(),
                grandTotal: Round(data?.netTotal + data?.taxAmount)?.toLocaleString(),
                // mode === 'offline'
                //   ? data.netTotal?.toLocaleString()
                //   : data.discount === 0
                //   ? data.total?.toLocaleString()
                //   : data.discountedTotal?.toLocaleString(),
                total: mode === 'online' && Round(data.total)?.toLocaleString(),
                detail: data?.technicalDetail,
                size: data?.size,
                inseam: data?.inseam || '',
                color: data?.color,
                brand: data?.brand,
                class: data?.class,
                category: data?.productCategory,
              }))
            }
            pagination={{
              position: ['bottomCenter'],
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
            scroll={{ x: 'auto' }}
          />
        </div>
      </Modal>
    </>
  )
}

export default InvoiceModal
